// Small timing helpers with no DOM dependencies.

export const BACKOFF_BASE_MS = 1000;
export const BACKOFF_MAX_MS = 15_000;

/** Exponential backoff: 1s, 2s, 4s, 8s, then capped at 15s. `attempt` starts at 0. */
export function backoffDelay(attempt: number): number {
  return Math.min(BACKOFF_BASE_MS * 2 ** attempt, BACKOFF_MAX_MS);
}

/** Milliseconds as m:ss, rounding up so the clock only shows 0:00 when time is really up. */
export function formatClock(ms: number): string {
  const seconds = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}
